import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[operationAccess]',
    standalone: false
})
export class OperationAccessDirective {

  private hasView = false;

  @Input() set operationAccess([meta, ...properties]) {
    if (!meta) {
      return;
    }

    this.setElementView(meta, Array.isArray(properties) ? properties : [properties]);
  }

  @Input() operationAccessElse?: TemplateRef<unknown>;


  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef
  ) { }

  private setElementView(meta: any, properties: string[]): void {
    const hasPermission = this.checkForPermission(meta, properties);

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (this.operationAccessElse) {
      this.viewContainer.createEmbeddedView(this.operationAccessElse);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private checkForPermission(meta: any, properties: string[]): boolean {
    return properties.every(property => {
      const deepValue = (object, path) => path.split('.').reduce((prev, key) => prev[key], object);
      const permission = deepValue(meta?.operations, property);
      if (permission === undefined) {
        console.error(`Access property "${property}" does not exist`);
        return true;
      }

      return permission;
    });
  }
}

